<style scoped lang="scss">
@media screen and (max-width: 640px) and (min-width: 600px){
  .online-service1{
    top: 80vh!important;
    li{
      .icon-box{
        width: 66px!important;
        height: 66px!important;
        img{
          margin-top: 0!important;
        }
        p{
          font-size: 14px;
          margin-top: 0!important;
        }
      }
    }
  }

}
.online-service1{
  position: fixed;
  z-index: 3;
  top:85vh;
  right:20px;
  li{
    cursor: pointer;
    .icon-box{
      width:50px;
      height:50px;
      border-radius: 50%;
      background: #EFF5FF;
      color: #014492;
      text-align: center;
      padding-top: 8px;
      margin-bottom: 20px;
      box-shadow: 0 0 14px 0 rgba(19, 72, 157, 0.1);
      p{
        font-size: 14px;
        margin-top: -7px;
      }
    }
  }
}
</style>
<template>
  <div class="one" style="overflow: auto">
    <div class=" online-service1">
      <ul>
        <li v-if="btnFlag">
          <div class="icon-box">
            <img  src="@/assets/images/img_top.png" @click="backTop" width="40%" style="margin-top: -3px;">
            <p>顶部</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'qk-service1',
  data () {
    return {
      btnFlag:false,
    }
  },
  mounted(){
    window.addEventListener('scroll', this.scrollToTop)
  },
// window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于1500显示回顶部图标，小于1500则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 1000) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/service_top.vue